import { VApp } from 'vuetify/lib/components/VApp';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"light":""}},[_c(VMain,[_c('div',{attrs:{"id":"core-view"}},[_c(VFadeTransition,{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('notifications',{attrs:{"group":"notifications","position":'top right'}}),_c('Loader'),_c('OuterBlock'),_c('IconBlock'),_c('ImageBlock'),_c('FormBlock')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }